<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMoreVertical_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.667 12c0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333-.6-1.333-1.333-1.333-1.333.6-1.333 1.333Zm0-8c0 .733.6 1.333 1.333 1.333S9.333 4.733 9.333 4 8.733 2.667 8 2.667 6.667 3.267 6.667 4Zm0 4c0 .733.6 1.333 1.333 1.333S9.333 8.733 9.333 8 8.733 6.667 8 6.667 6.667 7.267 6.667 8Z"
    />
</svg>
